import { ImagePlus } from "lucide-react";
import { cn } from "@/lib/utils";
import type { LifestylePicture } from "@/hooks/use-lifestyle-pictures";

const MAX = 5;

type Props = {
  pictures: LifestylePicture[];
  className?: string;
  emptyLabel?: string;
};

export default function LifestylePicsGrid({ pictures, className, emptyLabel }: Props) {
  const slots = Array.from({ length: MAX }).map((_, i) => pictures[i] ?? null);
  return (
    <div className={cn("grid grid-cols-5 gap-2", className)}>
      {slots.map((pic, i) => (
        <div
          key={pic?.id ?? `empty-${i}`}
          className="relative aspect-square overflow-hidden rounded-xl bg-gray-50 dark:bg-gray-900 ring-1 ring-gray-100 dark:ring-gray-800"
        >
          {pic?.picture_url ? (
            <img
              src={pic.picture_url}
              alt={`Lifestyle ${i + 1}`}
              className="h-full w-full object-cover"
            />
          ) : (
            <div className="flex h-full w-full flex-col items-center justify-center text-gray-300 dark:text-gray-700">
              <ImagePlus className="h-5 w-5" />
              {emptyLabel && i === 0 && (
                <span className="mt-1 text-[10px] text-gray-400 dark:text-gray-600 text-center px-1">
                  {emptyLabel}
                </span>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
